<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" />

        <action-button type="delete" @click="del(user.id)" v-if="user.id && $can('user-delete') && modal != true" :disabled="delete_disabled" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="person.first_name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('users.first_name')"
                  :error-messages="errors.collect('person.first_name')"
                  data-vv-name="person.first_name"
                  :disabled="fieldDisabled"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="person.last_name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('users.last_name')"
                  :error-messages="errors.collect('person.last_name')"
                  data-vv-name="person.last_name"
                  :disabled="fieldDisabled"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <vue-tel-input-vuetify
                  v-validate="'required|max:20'"
                  :label="$t('users.mobile')"
                  v-model="person.mobile"
                  @input="
                    (formattedNumber, { number, valid, country }) => {
                      person.mobile = number.significant || formattedNumber
                      person.mobile_code = country.dialCode || null
                    }
                  "
                  placeholder=""
                  name="person.mobile"
                  data-vv-name="person.mobile"
                  :error-messages="errors.collect('person.mobile')"
                  defaultCountry="NO"
                  :disabled="fieldDisabled"
                ></vue-tel-input-vuetify>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="participant.company_id"
                  v-model="user.company_ids"
                  item-text="name"
                  item-value="id"
                  :items="companies"
                  :label="$t('participants.company_id')"
                  :error-messages="errors.collect('participant.company_id')"
                  autocomplete="new-password"
                  :disabled="fieldDisabled"
                  clearable
                  multiple
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-expansion-panels :value="0" class="cstm-filter mt-4 elevation-0">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>{{ $t("users.account_title") }}</v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-flex md12>
                <v-container class="pa-0">
                  <v-layout row wrap>
                    <v-flex lg3 md4 sm6 xs12>
                      <v-text-field
                        v-model="user.email"
                        class="required-field"
                        v-validate="'required|max:255'"
                        :label="$t('users.email')"
                        :error-messages="errors.collect('user.email')"
                        data-vv-name="user.email"
                        autocomplete="new-password"
                        :disabled="fieldDisabled"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg3 md4 sm6 xs12 v-if="user && user.id">
                      <v-text-field
                        v-model="user.password"
                        :class="!user.id ? 'required-field' : ''"
                        v-validate="!_.has(this.user, 'id') ? 'required|password_strength' : 'password_strength'"
                        :label="$t('users.password')"
                        :error-messages="errors.collect('user.password')"
                        data-vv-name="user.password"
                        type="password"
                        :hint="$t('global.helptext_password')"
                        autocomplete="new-password"
                        persistent-hint
                        :disabled="fieldDisabled && field2Disabled"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg3 md4 sm6 xs12>
                      <v-select
                        name="user.status"
                        v-model="user.status"
                        class="required-field"
                        v-validate="'required'"
                        item-text="text"
                        item-value="key"
                        :items="this.$dd_user_status()"
                        :label="$t('users.status')"
                        :error-messages="errors.collect('user.status')"
                        :disabled="fieldDisabled"
                        clearable
                      ></v-select>
                    </v-flex>
                    <v-flex lg3 md4 sm6 xs12 v-if="from_module != 'enrolment-organisation'">
                      <v-checkbox v-model="user.is_instructor" :label="$t('users.is_instructor')" :disabled="fieldDisabled"></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels :value="0" class="cstm-filter mt-4 elevation-0">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>{{ $t("settings.title") }}</v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-flex md12>
                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                      <tr class="border-bottom">
                        <td scope="row" width="20%">{{ $t("settings.locale") }}</td>
                        <td>
                          <v-select
                            name="settings.locale"
                            v-model="setting.locale"
                            class="required-field"
                            v-validate="'required'"
                            item-text="text"
                            item-value="key"
                            :items="$dd_locales()"
                            :menu-props="settings.locale"
                            :error-messages="errors.collect('setting.locale')"
                            :disabled="fieldDisabled && field2Disabled"
                            clearable
                          ></v-select>
                        </td>
                      </tr>
                      <tr class="border-bottom">
                        <td scope="row" width="20%">{{ $t("settings.rows_per_page") }}</td>
                        <td>
                          <v-select
                            name="settings.rows_per_page"
                            v-model="setting.rows_per_page"
                            class="required-field"
                            v-validate="'required'"
                            :items="DATATABLE_ITEM_PER_PAGE_OPTIONS"
                            :error-messages="errors.collect('setting.rows_per_page')"
                            :disabled="fieldDisabled && field2Disabled"
                          ></v-select>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels :value="0" class="cstm-filter mt-4 elevation-0">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>{{ $t("roles.title") }}</v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-flex md12>
                <span v-for="all_role in all_roles" :key="all_role.id" class="mr-3">
                  <input
                    v-model="checked"
                    type="checkbox"
                    name="chk_role"
                    :value="all_role.slug"
                    :checked="checked.includes(all_role.slug)"
                    :disabled="fieldDisabled || from_module == 'enrolment-organisation' || all_role.disabled"
                    @change="roleChange"
                  />
                  {{ all_role.name }}
                </span>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          :value="0"
          class="cstm-filter mt-4 elevation-0"
          v-if="isOrganisationAdmin && predata && _.has(predata.user, 'is_instructor') && predata.user.is_instructor"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>{{ $t("users.course_types_and_group") }}</v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-flex md12>
                <v-container class="pa-0">
                  <v-layout row wrap>
                    <v-flex xl4 lg4 md6 sm6 xs12 v-for="(items, index) in ctg_ct_list_columns" :key="'list-' + index">
                      <v-card tile height="100%">
                        <!-- Course Type Group -->
                        <div v-for="ctg in items" :key="'ctg-' + ctg.key">
                          <v-list-item class="secondary" :v-if="ctg.type == 'coursetypegroup'">
                            <v-list-item-action>
                              <v-checkbox
                                v-model="user_coursetypegroups"
                                :value="ctg.id"
                                color="primary"
                                @change="courseTypeGroupChange(ctg.id)"
                                :disabled="fieldDisabled"
                              ></v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <v-list-item-title>
                                <span>{{ ctg.fullname }}</span>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>

                          <!-- Course Types -->
                          <v-list-item v-for="ct in ctg.coursetypes" :v-if="ct.type == 'coursetype'" :key="'ct-' + ct.id">
                            <v-list-item-action>
                              <v-checkbox
                                v-model="user_coursetypes"
                                :value="ct.id"
                                color="primary"
                                @change="courseTypeChange()"
                                :disabled="fieldDisabled"
                              ></v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <v-list-item-title>
                                <span>{{ ct.fullname }}</span>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          :value="0"
          class="cstm-filter mt-4 elevation-0"
          v-if="isOrganisationAdmin && predata && _.has(predata.user, 'is_instructor') && predata.user.is_instructor"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>{{ $t("educationprograms.title") }}</v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-flex md12>
                <v-container class="pa-0">
                  <v-layout row wrap>
                    <v-flex xl4 lg4 md6 sm6 xs12 v-for="item in educationprograms" :key="item.id">
                      <v-checkbox
                        v-model="user_educationprograms"
                        :value="item.id"
                        :label="item.name"
                        color="primary"
                        @change="courseTypeChange()"
                        class="pa-0 ma-0"
                        :disabled="fieldDisabled"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import PhoneNumber from "awesome-phonenumber"
import VueTelInputVuetify from "@/mixins/vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue"
export default {
  name: "UserForm",

  props: ["id",  "modal", "enrolment_organisation_id", "from_module"],

  components: {
    VueTelInputVuetify
  },

  data() {
    return {
      page_title: "",

      tab: null,
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",

      predata: {},
      user: {},
      person: {},
      setting: {
        locale: null,
        rows_per_page: null
      },

      settings: [],
      users: [],
      roles: [],
      all_roles: [],
      checked: [],

      admin_count: 0,
      delete_disabled: true,

      dictionary: {
        attributes: {
          "user.email": this.$t("users.email"),
          "user.password": this.$t("users.password"),
          "user.status": this.$t("users.status"),

          "person.first_name": this.$t("users.first_name"),
          //"person.middle_name": this.$t("users.middle_name"),
          "person.last_name": this.$t("users.last_name"),
          "person.mobile": this.$t("users.mobile"),
          "person.comments": this.$t("users.comments"),

          "participant.company_id": this.$t("participants.company_id"),
        }
      },
      organisations: [],
      companies: [],

      educationprograms: [],
      coursetypegroups: [],
      coursetypes: [],
      ctg_ct_list: [],
      ctg_ct_list_columns: [],

      user_coursetypegroups: [],
      user_coursetypes: [],
      user_educationprograms: [],

      toggleSelectAllCourseTypeGroup: false,
      toggleSelectAllCourseType: false,
      toggleSelectAllEducationProgram: false
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, { user: this.user, person: this.person }, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    isOrganisationAdmin() {
      return this.$hasRole("organisation-admin")
    },
    loggedinuser: {
      get() {
        return this.$store.getters["auth/user"]
      }
    },
    fieldDisabled() {
      let disabled = false

      if (
        (this.$hasRole("system-developer") || this.$hasRole("organisation-admin") || this.$hasRole("organisation-admin")) &&
        this.$can("user-edit")
      ) {
        disabled = false
      } else {
        disabled = true
      }

      if(this.from_module == 'enrolment-organisation') {
        disabled = false
      }

      return disabled
    },
    field2Disabled() {
      let disabled = false

      if (this.user && this.user.id && this.loggedinuser && this.loggedinuser.id && this.loggedinuser.id == this.user.id) {
        disabled = false
      } else {
        disabled = true
      }

      return disabled
    },
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    this.init()
  },

  watch: {
    toggleSelectAllCourseTypeGroup(val) {
      if (val) {
        this.user_coursetypegroups = this.coursetypegroups.map((a) => a.id)
      } else {
        this.user_coursetypegroups = [-1] // Hack to remove the list of course types in dropdown
      }

      this.courseTypeGroupChange()
    },
    toggleSelectAllCourseType(val) {
      if (val) {
        this.user_coursetypes = this.coursetypes.map((a) => a.id)
      } else {
        this.user_coursetypes = []
      }
    },
    toggleSelectAllCourseType(val) {
      if (val) {
        this.user_educationprograms = this.educationprograms.map((a) => a.id)
      } else {
        this.user_educationprograms = []
      }
    }
  },

  methods: {
    init() {
      if (this.$router.currentRoute.path == this.BACKEND_URL + "/profile") {
        this.id = this.loggedinuser.id
      }

      let lists = [
        { key: "coursetypegroups", module: "coursetypegroups", query: "show_all=true&sort_by=category&sort_order=asc" },
        { key: "educationprograms", module: "educationprograms", query: "show_all=true&sort_by=name&sort_order=asc" },
        { key: "enrolled_organisations", module: "enrolled_organisations", query: "show_all=true" }
      ]

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.coursetypegroups = res.data.coursetypegroups
        this.educationprograms = res.data.educationprograms
        this.companies = res.data.enrolled_organisations

        this.courseTypeAndGroupList()

        if (!this.id) {
          this.page_title = this.$t("users.new_user")

          this.user = {
            company_ids: [],
            status: 1,
          }

          this.setting.locale = 'no'
          this.setting.rows_per_page = 20

          if(this.enrolment_organisation_id) {
            this.user.company_ids.push(this.enrolment_organisation_id)
          }

          // JSON stringify and parse to remove variable reactiveness
          this.loadPredata()

          this.getRoles()
        } else {
          axios
            .get(this.API_URL + "user/" + this.id)
            .then((res) => {
              this.user = res.data.data
              this.person = res.data.data.person
              this.roles = res.data.data.roles
              this.settings = res.data.data.settings

              this.setting.locale = this.settings.find((i) => i.key == "locale").value
              this.setting.rows_per_page = Number(this.settings.find((i) => i.key == "rows_per_page").value)

              this.user_coursetypegroups = this.user.coursetypegroups.map((a) => a.id)
              this.user_coursetypes = this.user.coursetypes.map((a) => a.id)
              this.user_educationprograms = this.user.educationprograms.map((a) => a.id)

              // JSON stringify and parse to remove variable reactiveness
              this.loadPredata()

              this.page_title = this.$t("users.edit_user", { name: this.person.first_name + " " + this.person.last_name })

              this.getUsers()
              this.getRoles()
            })
            .catch((err) => console.log(err))
        }
      })
    },
    loadPredata() {
      this.predata = JSON.parse(JSON.stringify({ user: this.user, person: this.person }))
      this.predata.person.mobile_code = "47" // Norway country code

      if (this.predata.person.mobile) {
        let code = PhoneNumber(this.predata.person.mobile).getCountryCode()
        if (code) {
          let mobileJSON = PhoneNumber(this.predata.person.mobile).toJSON()
          this.predata.person.mobile = mobileJSON.number.significant || this.predata.person.mobile
          this.predata.person.mobile_code = code.toString()
        }
      }

      if (!this.user.id) {
        this.person.mobile_code = this.predata.person.mobile_code
      } else {
        this.predata.user.person.mobile = this.predata.person.mobile
        this.predata.user.person.mobile_code = this.predata.person.mobile_code
      }

    },
    fn_toggleSelectAllCourseTypeGroup() {
      this.toggleSelectAllCourseTypeGroup = !this.toggleSelectAllCourseTypeGroup
    },
    fn_toggleSelectAllCourseType() {
      this.toggleSelectAllCourseType = !this.toggleSelectAllCourseType
    },
    fn_toggleSelectAllEducationProgram() {
      this.toggleSelectAllEducationProgram = !this.toggleSelectAllEducationProgram
    },
    courseTypeAndGroupList() {
      let vm = this
      let total_count = 0

      vm.ctg_ct_list_columns = []

      // Count total group and coursetype
      vm.coursetypegroups.forEach((ctg) => {
        let ct_ids = ctg.coursetypes.map((a) => a.id)
        total_count++ // Add to count the course type group
        total_count += ct_ids.length // Add course types count
      })

      // Get breakpoint
      let col_count =
        this.$vuetify.breakpoint.xl || this.$vuetify.breakpoint.lg
          ? 3
          : this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.sm
          ? 2
          : this.$vuetify.breakpoint.xs
          ? 1
          : null

      // Set row count
      let row_count = Math.ceil(total_count / col_count)

      vm.coursetypegroups.forEach((ctg) => {
        let count = 1 + ctg.coursetypes.map((a) => a.id).length
        let len = vm.ctg_ct_list_columns.length

        // add new property in ctg variable
        ctg.key = "ctg-" + ctg.id
        ctg.type = "coursetypegroup"

        // add new property in ctg.coursetypes variable
        ctg.coursetypes.forEach((ct) => {
          ct.key = "ct-" + ct.id
          ct.type = "coursetype"
        })

        // If ctg_ct_list_columns length does not have any value
        if (len == 0) {
          // push new array
          vm.ctg_ct_list_columns.push(new Array())

          // insert course type group in the ctg_ct_list_columns array
          var new_index = vm.ctg_ct_list_columns.length - 1
          vm.ctg_ct_list_columns[new_index].push(ctg)
        } else {
          // variable to check if we need to create new array or note
          let create_new = true
          // variable to check if we need to insert the coursetype group in the existing array, save the index in this var
          let insert_index = null

          // loop thru ctg_ct_list_columns array to check if we need to create new or insert the course type group
          vm.ctg_ct_list_columns.forEach((group, index) => {
            let inner_count = 0

            // count all the items (course type and course type group) inside the array
            vm.ctg_ct_list_columns[index].forEach((item) => {
              inner_count += 1 + item.coursetypes.map((a) => a.id).length
            })

            // check if we can insert the ctg variable to an existing array
            if (inner_count + count <= row_count) {
              create_new = false
              insert_index = index
            }
          })

          if (create_new) {
            vm.ctg_ct_list_columns.push(new Array())

            var new_index = vm.ctg_ct_list_columns.length - 1
            vm.ctg_ct_list_columns[new_index].push(ctg)
          } else {
            vm.ctg_ct_list_columns[insert_index].push(ctg)
          }
        }
      })
    },
    courseTypeGroupChange(id) {
      let vm = this
      let ctg = vm.coursetypegroups.find((i) => i.id == id)

      if (ctg) {
        let ctg_ct_ids = ctg.coursetypes.map((a) => a.id)

        if (!vm.user_coursetypegroups.includes(ctg.id)) {
          // Clear all coursetype of the selected group
          vm.user_coursetypes = vm.user_coursetypes.filter(function (n) {
            return !ctg_ct_ids.includes(n)
          })
        } else {
          // Check all coursetype of the selected group
          ctg_ct_ids.forEach((ctid) => {
            if (!vm.user_coursetypes.includes(ctid)) {
              vm.user_coursetypes.push(ctid)
            }
          })
        }
      }
    },
    courseTypeChange() {
      let vm = this

      vm.coursetypegroups.forEach((ctg) => {
        let shouldCheck = false

        ctg.coursetypes.forEach((ct) => {
          if (vm.user_coursetypes.includes(ct.id)) {
            shouldCheck = true
          }
        })

        if (shouldCheck) {
          // Check if course type group id is already in the allowed_coursetypegroups array, if NOT, then it will be added
          if (!vm.user_coursetypegroups.includes(ctg.id)) {
            vm.user_coursetypegroups.push(ctg.id)
          }
        } else {
          // Delete the course type group id in allowed_coursetypegroups array, if there are no course types checked
          if (vm.user_coursetypegroups.indexOf(ctg.id) !== -1) {
            vm.user_coursetypegroups.splice(vm.user_coursetypegroups.indexOf(ctg.id), 1)
          }
        }
      })
    },
    getUsers() {
      this.$store.dispatch("master/setAxiosHideLoader", true)
      axios.post(this.API_URL + "request/ddlists", [{ key: "users", module: "users", query: "show_all=true" }]).then((res) => {
        this.users = res.data.users

        this.admin_count = this.users.filter((i) => {
          if (i.roles) {
            return i.roles.find((i) => i.slug == "organisation-admin")
          }
        }).length

        if (this.user.id == this.loggedinuser.id) {
          this.delete_disabled = true
        } else {
          this.delete_disabled = Boolean(this.admin_count < 2 && this.user.roles.filter((i) => i.slug == "organisation-admin"))
        }
      })
    },
    getRoles() {
      let vm = this
      vm.checked = []

      this.roles.forEach(function (value) {
        vm.checked.push(value.slug)
      })

      // Get user roles
      vm.$store.dispatch("master/setAxiosHideLoader", true)
      axios
        .get(this.API_URL + "roles")
        .then((res) => {
          this.all_roles = res.data.data
          this.all_roles =  this.all_roles.map((r) => ({
            ...r,
            disabled: false
          }))

          if(this.from_module == 'enrolment-organisation') {
            this.all_roles = this.all_roles.filter(i => i.slug == 'company')
            this.checked.push('company')
          }

          this.roleChange()
        })
        .catch((err) => console.log(err))
    },
    saveRoles(id) {
      let vm = this

      vm.$store.dispatch("master/setAxiosHideLoader", true)
      axios
        .post(this.API_URL + "user/roles", {
          id: id,
          roles: vm.checked
        })
        .then((res) => {
          let data = res.data.data

          if (data.id) {
            vm.$store.dispatch("auth/updateUserState", vm)
          }
        })
        .catch((err) => console.log(err))
    },
    saveSettings() {
      let vm = this
      let data = []

      data.push({ key: "locale", value: this.setting.locale })
      data.push({ key: "rows_per_page", value: this.setting.rows_per_page })

      vm.$store.dispatch("master/setAxiosHideLoader", true)
      axios
        .post(this.API_URL + "setting", {
          user_id: this.user.id,
          data: JSON.stringify(data)
        })
        .then((res) => {
          if (res.data.data) {
            vm.settings = res.data.data
          }
        })
        .catch((err) => console.log(err))
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            if (!_.has(this.user, "id")) {
              // Create
              axios
                .post(this.API_URL + "user", {
                  email: vm.user.email,
                  password: vm.user.password,
                  status: vm.user.status,
                  is_instructor: vm.user.is_instructor,
                  company_ids: vm.user.company_ids.join(","),
                  person: {
                    first_name: vm.person.first_name,
                    last_name: vm.person.last_name,
                    middle_name: vm.person.middle_name,
                    mobile: vm.$formatPhoneNumber(vm.person.mobile, vm.person.mobile_code),
                    organisation_id: vm.$store.getters["organisations/organisationId"]
                  },
                  coursetypegroups: this.user_coursetypegroups.join(","),
                  coursetypes: this.user_coursetypes.join(","),
                  educationprograms: this.user_educationprograms.join(",")
                })
                .then((res) => {
                  vm.user = res.data.data
                  vm.person = res.data.data.person
                  vm.roles = res.data.data.roles

                  vm.loadPredata()

                  vm.user_coursetypegroups = vm.user.coursetypegroups.map((a) => a.id)
                  vm.user_coursetypes = vm.user.coursetypes.map((a) => a.id)
                  vm.user_educationprograms = vm.user.educationprograms.map((a) => a.id)

                  vm.saveRoles(vm.user.id)
                  vm.saveSettings()
                  vm.getUsers()

                  vm.$awn.success(vm.$t("global.create_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "users",
                      mode: "add",
                      data: res.data.data
                    })
                  } else {
                    vm.page_title = vm.$t("users.edit_user", { name: vm.person.first_name + " " + vm.person.last_name })
                    vm.$router.replace(this.BACKEND_URL + `/users/edit/${vm.user.id}`).catch(() => {})
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "user", {
                  id: vm.user.id,
                  email: vm.user.email,
                  password: vm.user.password,
                  status: vm.user.status,
                  is_instructor: vm.user.is_instructor,
                  company_ids: vm.user.company_ids.join(","),
                  person: {
                    first_name: vm.person.first_name,
                    last_name: vm.person.last_name,
                    middle_name: vm.person.middle_name,
                    mobile: vm.$formatPhoneNumber(vm.person.mobile, vm.person.mobile_code),
                    comments: vm.person.comments,
                    organisation_id: vm.$store.getters["organisations/organisationId"]
                  },
                  coursetypegroups: this.user_coursetypegroups.join(","),
                  coursetypes: this.user_coursetypes.join(","),
                  educationprograms: this.user_educationprograms.join(",")
                })
                .then((res) => {
                  vm.user = res.data.data
                  vm.person = res.data.data.person
                  vm.roles = res.data.data.roles

                  vm.loadPredata()

                  vm.user_coursetypegroups = vm.user.coursetypegroups.map((a) => a.id)
                  vm.user_coursetypes = vm.user.coursetypes.map((a) => a.id)
                  vm.user_educationprograms = vm.user.educationprograms.map((a) => a.id)

                  vm.saveRoles(vm.user.id)
                  vm.saveSettings()
                  vm.getUsers()

                  vm.page_title = vm.$t("users.edit_user", { name: vm.person.first_name + " " + vm.person.last_name })
                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "users",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "user/" + id)
            .then(() => {
              vm.$router.push(vm.BACKEND_URL + "/users")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    phoneNoSpace() {
      if (this.person.mobile) {
        this.person.mobile = this.person.mobile.replace(/\s/g, "")
        let field = this.errors.items.find((i) => i.field == "person.mobile" && i.rule == "no_space")
        if (field) this.$validator.errors.removeById(field.id)
      }
    },
    roleChange() {
      if(this.checked.length > 0) {
        if(this.checked.includes("api")) {
          this.all_roles.filter(i => i.slug != "api").map(j => j.disabled = true)
        } else {
          this.all_roles.filter(i => i.slug == "api").map(j => j.disabled = true)
        }
      } else {
        this.all_roles.map(j => j.disabled = false)
      }
    }
  }
}
</script>

<style scoped></style>
